module.exports = __webpack_public_path__ + "img/98bbdc_EN.00a517ab.jpg";